// This file overwrites the stock UV config.js

self['u3xb32m85ql1mR4ZB]AnC72'] = {
  prefix: '/network/service/',
  encodeUrl: Ultraviolet.codec.xor.encode,
  decodeUrl: Ultraviolet.codec.xor.decode,
  handler: '/network/networking.handler.js',
  client: '/network/networking.client.js',
  bundle: '/network/networking.bundle.js',
  config: '/network/networking.config.js',
  sw: '/network/networking.sw.js',
};
